import React from 'react';
import { Skeleton, SkeletonImage } from 'seduo-ui';
const Example = () => (<div className="card card-program h-100 shadow-sm" style={{
        maxWidth: '358px',
    }}>
        <SkeletonImage className="image card-program__image" wrapperClassName="card-program__image-wrapper"/>
        <div className="card-body card-program__body">
            <div className="mb-6">
                <Skeleton type="title" lines={2} standalone={false}/>
            </div>
            <Skeleton lines={3}/>
        </div>
        <div className="card-program__footer">
            <div className="card-program__footer-wrapper">
                <div className="card-course__text">
                    <Skeleton width="150px"/>
                </div>
                <div className="card-course__text text-secondary">
                    <a className="link card-course__link card-course__link--with-icon" href="#">
                        <Skeleton width="100px"/>
                    </a>
                </div>
            </div>
        </div>
    </div>);
export default Example;
